import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Label } from "./ui/label";
import { Check, Sparkles } from "lucide-react";

const MAX = 3;

export default function SegmentsPicker({ value = [], onChange, testid = "seg-picker" }) {
  const [segments, setSegments] = useState([]);

  useEffect(() => {
    api.get("/segments?active=true").then((r) => setSegments(r.data || [])).catch(() => {});
  }, []);

  const toggle = (slug) => {
    const current = value || [];
    if (current.includes(slug)) {
      onChange(current.filter((s) => s !== slug));
    } else if (current.length < MAX) {
      onChange([...current, slug]);
    }
  };

  return (
    <div data-testid={testid}>
      <Label className="flex items-center gap-1.5"><Sparkles size={14} className="text-amber-600"/> Segmentos do Descobrir <span className="text-xs font-normal text-stone-500">(até {MAX})</span></Label>
      <p className="text-[11px] text-stone-500 mt-1 mb-2">Escolha em quais segmentos sua empresa aparece (ex.: "Onde Comer Bem"). Selecionados: {(value || []).length}/{MAX}.</p>
      <div className="flex flex-wrap gap-2">
        {segments.length === 0 && <p className="text-xs text-stone-400">Nenhum segmento cadastrado.</p>}
        {segments.map((s) => {
          const selected = (value || []).includes(s.slug);
          const disabled = !selected && (value || []).length >= MAX;
          return (
            <button
              key={s.slug}
              type="button"
              disabled={disabled}
              onClick={() => toggle(s.slug)}
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-semibold border transition-all ${
                selected
                  ? "bg-blue-900 text-white border-blue-900"
                  : disabled
                  ? "bg-stone-100 text-stone-400 border-stone-200 cursor-not-allowed"
                  : "bg-white text-stone-700 border-stone-200 hover:border-blue-900 hover:text-blue-900"
              }`}
              data-testid={`${testid}-${s.slug}`}
            >
              {selected && <Check size={12}/>} {s.cta || s.name}
            </button>
          );
        })}
      </div>
    </div>
  );
}
